import { Temporal } from '@js-temporal/polyfill';
import { installClientClockOffset } from './modules/clock.ts';
import { $$ } from './modules/dom.ts';

// Honor dev --at time travel before reading Temporal.Now below.
installClientClockOffset();

const { Now, Instant } = Temporal;

const relative = (seconds: number) => {
  const d = roundDuration(Now.instant().until(Instant.fromEpochMilliseconds(seconds * 1e3)));
  if (d.sign === 0) {
    return 'Now!';
  } else {
    if (d.abs().total('minutes') < 60) {
      return d.toLocaleString('en', { style: 'digital' });
    } else {
      const s = d.abs().toLocaleString('en', { style: 'short' });
      return d.sign < 0 ? `${s} ago` : `In ${s}`;
    }
  }
};

const timer = (timestamp: number) => {
  if (timestamp === -1) {
    return '-';
  } else {
    const d = since(timestamp).round({ smallestUnit: 'seconds', largestUnit: 'hours' });
    return d.toLocaleString('en', { style: 'digital', hoursDisplay: 'auto' });
  }
};

const since = (timestamp: number) =>
  Now.instant().since(Instant.fromEpochMilliseconds(timestamp * 1e3));

const roundDuration = (d: Temporal.Duration) => {
  d = d.round({ smallestUnit: 'seconds', largestUnit: 'days' });
  if (Math.abs(d.days) > 0) {
    d = d.round({ smallestUnit: 'days' });
  } else if (Math.abs(d.hours) > 0) {
    d = d.round({ smallestUnit: 'hours' });
  } else if (Math.abs(d.minutes) > 0) {
    d = d.round({ smallestUnit: 'seconds' });
  }
  return d;
};

const update = () => {
  $$('.relative[data-timestamp]').forEach((s: HTMLElement) => {
    s.innerText = relative(Number(s.dataset.timestamp));
  });
  $$('.timer[data-timestamp]').forEach((s: HTMLElement) => {
    if (!s.classList.contains('stopped')) {
      s.innerText = timer(Number(s.dataset.timestamp));
    }
  });
};

setInterval(update, 1000);
